export default "__VITE_ASSET__ab2fd255__"